module.exports = __webpack_public_path__ + "static/img/group_honor.892ca06c.png";